//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, post } from '@api/request';
import { mdtfAPI } from '@api/modules/mdtf';
import { qrcdAPI } from '@api/modules/qrcd';
import { optnAPI } from '@api/modules/optn';
import addHeader from '@/views/component/addHeader';
import inputUser from '@/views/component/inputUser';
import { mqcdAPI } from '@api/modules/mqcd';
export default {
  name: 'mdtfAddMain',
  components: {
    addHeader: addHeader,
    inputUser: inputUser
  },
  data: function data() {
    return {
      mdtfForm: {
        mdtf_type: null,
        qrcd_no: null,
        mdrl_id: null,
        mdrl_no: null,
        mdrl_name: null,
        mdrl_unit: null,
        mdrl_type: null,
        mdrl_num: null,
        mdrl_width: null,
        mdrl_color: null,
        mdrl_spec: null,
        qrcd_bin: null,
        user_id: null,
        stff_id: null,
        dept_id: null,
        mdtf_length: null,
        mdtf_width: null,
        status: 0,
        mdtf_remark: null,
        key: 0,
        belo_dept_id: null //所属部门

      },
      binList: [],
      mdrlType: [{
        id: 1,
        label: '钢材'
      }, {
        id: 2,
        label: '辅材'
      }],
      mdrlTypeGroupOpt: [],
      title: '',
      binFlag: false,
      numFlag: false,
      mdrlType1: '原面料',
      mdrlType2: '辅料',
      mdrlType3: '包材',
      mdrlType4: '',
      disableFlag: false,
      option: [] //所属部门

    };
  },
  watch: {},
  created: function created() {
    this.initData();
  },
  mounted: function mounted() {
    this.$refs.inputs.focus();
  },
  methods: {
    initData: function initData() {
      this.getMdtfType();
      this.getBinList();
    },
    // 获取库位信息
    getBinList: function getBinList() {
      var _this = this;

      get(optnAPI.getAllContent, {
        perm_id: 10006
      }).then(function (res) {
        if (res.data.code === 0) {
          _this.binList = res.data.data;
        }
      });
    },
    // 获取单位
    getMdtfType: function getMdtfType() {
      var _this2 = this;

      get(optnAPI.getAllContent, {
        perm_id: 10005
      }).then(function (res) {
        if (res.data.code === 0) {
          _this2.mdrlTypeGroupOpt = res.data.data;
        }
      });
    },
    //提交表单
    submit: function submit(formName) {
      var _this3 = this;

      this.$confirm('确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.$refs[formName].validate(function (valid) {
          if (valid) {
            _this3.saveInfo1();
          } else {
            console.log('error submit!');
            return false;
          }
        });
      });
    },
    // 保存出库
    saveInfo1: function saveInfo1() {
      var _this4 = this;

      if (this.mdtfForm.mqcd_bin) {
        var staffForm = this.$refs.userData.getData();
        this.mdtfForm.mdtf_type = 1;
        this.mdtfForm = Object.assign(this.mdtfForm, staffForm);
        post(mdtfAPI.stockOut, this.mdtfForm).then(function (res) {
          if (res.data.code === 0) {
            _this4.$message({
              type: 'success',
              message: '保存成功'
            });

            _this4.disableFlag = false;
            var permId = _this4.$route.query.perm_id;

            _this4.jump("/mdtf_list?perm_id=".concat(permId));

            _this4.resetForm('mdtfForm');

            _this4.$refs.inputs.focus();

            _this4.$EventBus.$emit('uploading', 12345);
          } else if (res.data.code === 7) {
            _this4.$message({
              type: 'error',
              message: '库位中已有此材料'
            });
          } else {
            _this4.initData();
          }
        }).catch(function () {
          _this4.$message({
            type: 'error',
            message: '请输入正确的二维码编号'
          });

          _this4.resetForm('mdtfForm');
        });
      } else {
        this.$message({
          type: 'error',
          message: '该材料暂未入库,请先入库'
        });
      }
    },
    //取消
    cancel: function cancel() {
      var _this5 = this;

      this.$confirm('确定取消新增?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        _this5.resetForm('mdtfForm');

        _this5.$router.go(-1);

        _this5.$message({
          type: 'info',
          message: '已取消新增!'
        });
      });
    },
    // 扫码按下enter键导入材料
    inputDown: function inputDown() {
      var _this6 = this;

      if (!this.mdtfForm.qrcd_no) {
        return this.$message.warning('请先输入二维码编号');
      }

      this.$refs.inputs.blur();
      get(mqcdAPI.getMqcdById, {
        mqcd_no: this.$refs.inputs.$options.propsData.value
      }).then(function (res) {
        if (res.data.code === 0) {
          _this6.disableFlag = true;

          _this6.mdrlExport(res.data.data.form);
        } else if (res.data.code === 7) {
          _this6.$message({
            type: 'error',
            message: '库位中已有此材料'
          });
        } else {
          _this6.initData();
        }
      });
    },
    // 清空
    emptyInput: function emptyInput() {
      this.resetForm('mdtfForm');
      this.disableFlag = false;
    },
    // 材料出库导入确认
    mdrlExport: function mdrlExport(val) {
      var no = this.mdtfForm.qrcd_no;
      this.mdtfForm = val;
      this.mdtfForm.qrcd_no = no;
    },
    //表单重置
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.mdtfForm.qrcd_bin = null;
      this.numFlag = false;
      this.mdtfForm.mdrl_num = null;
    }
  }
};